// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"263":"698d2707","367":"3ede2064","449":"3ede2064","628":"f462259f"}[chunkId] + ".chunk.css";
};